import axios from '../../../utils/axios';

export function changePassword(oldPassword: string, newPassword: string) {
  return axios.post('auth/users/me/changepassword', {
    old_password: oldPassword,
    new_password: newPassword,
  });
}
